import { useSidebar } from "../context/SidebarContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useMobile from "../hooks/useMobile";
import { useUser } from "../context/UserContext";
import { useEffect, useRef, useState } from "react";
import NotificationDrawer from "./NotificationDrawer";
import { searchItems } from "./searchData";

const SearchHeader = () => {
  const { setSidebarOpen } = useSidebar();
  const navigate = useNavigate();
  // const [scrolled, setScrolled] = useState(false);
  const isMobile = useMobile();

  // useEffect(() => {
  //   const handleScroll = () => {
  //     setScrolled(window.scrollY > 20);
  //   };

  //   window.addEventListener("scroll", handleScroll);

  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);
  const { user } = useUser();

  const location = useLocation();

  const isDashboard = location.pathname === "/";
  const [showNotification, setShowNotification] = useState(false);

  const [search, setSearch] = useState("");
  const [filteredItems, setFilteredItems] = useState(searchItems);
  const [showDropdown, setShowDropdown] = useState(false);

  const searchRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const sectionId = location.state?.sectionId;

    if (!sectionId) return;

    const timer = setTimeout(() => {
      const element = document.getElementById(sectionId);

      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

        navigate(location.pathname, {
          replace: true,
          state: {},
        });
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [location, navigate]);

  useEffect(() => {
    if (!search.trim()) {
      setFilteredItems(searchItems);
      return;
    }

    setFilteredItems(
      searchItems.filter(
        (item) =>
          item.title.toLowerCase().includes(search.toLowerCase()) ||
          item.description.toLowerCase().includes(search.toLowerCase()),
      ),
    );
  }, [search]);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (searchRef.current && !searchRef.current.contains(e.target as Node)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    // <div
    //   className={`header d-flex align-items-center justify-content-between gap-3 ${
    //     scrolled ? "header-scrolled" : ""
    //   }`}
    // >
    <>
      <div
        className={`header d-flex align-items-center justify-content-between gap-3`}
      >
        {/* Search */}
        <button
          className="btn hamburger-icon p-0"
          onClick={() => setSidebarOpen(true)}
        >
          <i className="fa-solid fa-bars"></i>
        </button>
        {!isDashboard && (
          <span
            className="d-flex align-items-center gap-2 header-back-btn"
            onClick={() => navigate(-1)}
          >
            <i className="fa-solid fa-angle-left"></i>
            {`Back ${!isMobile ? "to Previous Page" : ""}`}
          </span>
        )}
        <div className="search-box position-relative" ref={searchRef}>
          <input
            type="text"
            className="form-control"
            placeholder="Search"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setShowDropdown(true);
              setShowDropdown(e.target.value.trim().length > 0);
            }}
          />

          {showDropdown && (
            <div className="search-dropdown">
              {filteredItems.length > 0 ? (
                filteredItems.map((item) => (
                  <div
                    key={item.id}
                    className="search-item"
                    onClick={() => {
                      navigate(item.path, {
                        state: {
                          sectionId: item.sectionId,
                          tab: item.tab,
                        },
                      });
                      setSearch("");
                      setShowDropdown(false);
                    }}
                  >
                    <div style={{ fontSize: "12px" }}>{item.title}</div>
                    <small>{item.description}</small>
                  </div>
                ))
              ) : (
                <div className="search-item text-muted">No results found</div>
              )}
            </div>
          )}
        </div>

        {/* Right Side */}
        <div className="d-flex align-items-center gap-3">
          <i
            className="fa-solid fa-bell cursor-pointer"
            onClick={() => setShowNotification(true)}
          ></i>

          <Link
            to={`/user/view/${user?.user.id}`}
            className="text-decoration-none"
          >
            <img
              src={`${process.env.REACT_APP_Url}/${user?.user.documentUrl}`}
              alt="user"
              className="user-img"
            />
          </Link>
        </div>
      </div>
      <NotificationDrawer
        open={showNotification}
        onClose={() => setShowNotification(false)}
      />
    </>
  );
};

export default SearchHeader;
